export default "d3dfecf18a711df5.svg"